import {FormatUtils} from '@/utils/FormatUtils';

export const MOSCOW_TIMEZONE_OFFSET_IN_HOURS = 3;
export const MILLISECONDS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 3600;
export const HOURS_IN_DAY = 24;

export class DateUtils {
  static secondsToMilliseconds(seconds: number): number {
    return seconds * MILLISECONDS_IN_SECOND;
  }

  static millisecondsToSeconds(seconds: number): number {
    return seconds / MILLISECONDS_IN_SECOND;
  }

  static millisecondsToDays(milliseconds: number): number {
    return Math.trunc(milliseconds / (MILLISECONDS_IN_SECOND * SECONDS_IN_HOUR * HOURS_IN_DAY));
  }

  static millisecondsToHours(milliseconds: number): number {
    return Math.trunc(milliseconds / MILLISECONDS_IN_SECOND / SECONDS_IN_HOUR);
  }

  static minutesToMilliseconds(minutes: number): number {
    return minutes * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
  }

  static minutesToSeconds(minutes: number): number {
    return minutes * SECONDS_IN_MINUTE;
  }

  static secondsToDays(seconds: number): number {
    return Math.trunc(seconds / SECONDS_IN_HOUR / HOURS_IN_DAY);
  }

  static daysToSeconds(days: number): number {
    return days * SECONDS_IN_HOUR * HOURS_IN_DAY;
  }

  static hoursToSeconds(hours: number): number {
    return hours * SECONDS_IN_HOUR;
  }

  static hoursToMilliseconds(hours: number): number {
    return hours * SECONDS_IN_HOUR * MILLISECONDS_IN_SECOND;
  }

  static getHourRemainderBySeconds(seconds: number): number {
    return Math.trunc((seconds / SECONDS_IN_HOUR) % HOURS_IN_DAY);
  }

  static getMinutesRemainderBySeconds(seconds: number): number {
    return Math.trunc((seconds / SECONDS_IN_MINUTE) % SECONDS_IN_MINUTE);
  }

  static getSecondsRemainderBySeconds(seconds: number): number {
    return Math.trunc(seconds % SECONDS_IN_MINUTE);
  }

  static getTimeToNextMoscowDay = (): string => {
    const nowLocal = new Date();
    const nowUTC = new Date(nowLocal.getTime() + DateUtils.minutesToMilliseconds(nowLocal.getTimezoneOffset()));
    const moscowUTC = new Date(nowUTC.getTime() + DateUtils.hoursToMilliseconds(MOSCOW_TIMEZONE_OFFSET_IN_HOURS));
    const nextMoscowDay = new Date(moscowUTC.getFullYear(), moscowUTC.getMonth(), moscowUTC.getDate() + 1);
    const timeRemaining = Math.max(0, nextMoscowDay.getTime() - moscowUTC.getTime());

    return FormatUtils.formatDailyMiniGameTimer(DateUtils.millisecondsToSeconds(timeRemaining));
  };

  static isLocalNight(): boolean {
    const date = new Date();
    const hours = date.getHours();
    return hours >= 22 || hours <= 7;
  }
}
